import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ConditionService = /** @class */ (function () {
    function ConditionService(http) {
        this.http = http;
    }
    ConditionService.prototype.getCondition = function (q) {
        var params = {
            q: q
        };
        return this.http.get('condition/', { params: params });
    };
    ConditionService.ngInjectableDef = i0.defineInjectable({ factory: function ConditionService_Factory() { return new ConditionService(i0.inject(i1.HttpClient)); }, token: ConditionService, providedIn: "root" });
    return ConditionService;
}());
export { ConditionService };
